exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".amount-title{text-align:center;font-weight:700;color:#4b2d15;font-size:17px;padding:3px 0}.text-center2{text-align:center;color:#969fad;white-space:nowrap;font-size:12px}.font-color{color:#969fad}.beepoint-svg{cursor:pointer}.beepoint-svg img{width:48px;height:48px}.diamond-svg{cursor:pointer}.diamond-svg img{width:48px;height:48px}.honey-jars-svg{cursor:pointer}.honey-jars-svg img{width:48px;height:48px}.rating-svg{cursor:pointer}.rank-svg img,.rating-svg img{width:48px;height:48px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2e085ea2","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/UserProfile/Achieve.vue
// module id = 1055
// module chunks = 0